import * as R from 'ramda'
import tap from 'tap-logger'
import StickerMessagePreview from '../components/sticker-message-preview.vue'
window.R = R

const processStamps = labels => R.pipe(
	R.chain(label =>
		R.map(stamp =>
				({
				font: R.pathOr({}, ['font'], label),
				container: R.pathOr({}, ['template', 'container'], label),
				stamp
				}),
			label.template.stamps
		)
	)
)(labels)


export const confirmation = {
	el: '#confirmation-vue',
	mixins: [],
	components: {
		StickerMessagePreview
	},

	ready() {
		this.processedProducts = this.processProducts(this.items)
	},

	watch: {
		cart() {
			this.processedProducts = this.processProducts(this.items)
		},

		previewData() {
			this.fonts = R.pipe(
				R.pathOr([], ['stamps']),
				R.map(R.path(['font', 'google_url'])),
				R.reject(R.isNil),
				R.concat(this.fonts),
				R.uniq,
			)(this.previewData)

			this.$broadcast('resize-font')
		},
	},

	data: {
		processedProducts: [],//no la hacemos computada porque necesitamos tener la refencia al objeto cuando hacemos los updates de cantidad, y las propiedades computadas no nos permite hacer esto fácilmente
		previewCache: {},//{item_id: StickerPreview}
		previewedSticker: {},
		fonts: [],
		purchased: {}
	},

	computed: {
		products() {
			return R.pathOr([], ['store', 'cart', 'data'], this)
		},


		hasProducts() {
			return this.processedProducts.length > 0
		},

		cart() {
			return R.pathOr({}, ['store', 'cart', 'data'], this)
		},

		items() {
			return R.pathOr([], ['cart', 'items'], this)
		},

		subtotal() {
			return R.pathOr('$0', ['cart', 'formated_subtotal'], this)
		},

		total() {
			return R.pathOr('$0', ['cart', 'formated_total'], this)
		},

		previewData() {

			return R.pipe(
				R.pick(['customizations', 'labels']),
				({customizations, labels}) => ({
					texts: R.pathOr([], ['texts'], customizations),
					stamps: processStamps(labels || {}),
				}),
			)(this.previewedSticker)
		},

	},

	methods: {
		isEmpty: R.isEmpty,

		processProducts(items) {
			return R.pipe(
				R.map(
					({
						item_id,
						description,
						name,
						formated_buyable_price,
						formated_total_buyable_price,
						customizations,
						quantity,
						thumbnail_url,
						computed_description,
						application_url
					}) =>
					({
						item_id,
						description,
						name,
						price: formated_buyable_price,
						total_price: formated_total_buyable_price,
						texts: R.pathOr([], ['texts'], customizations),
						quantity,
						new_quantity: quantity,
						img: thumbnail_url,
						computed_description,
						application_url
					})
				)
			)(items)
		},

		quantityHasChanged(product) {
			return product.quantity !== Number(product.new_quantity)
		},

		updateQuantity(product) {
			let url = R.pipe(
				R.replace('__id__', product.item_id),
			)(this.$root.store.routes.updateQuantity.post)

			this.$http.post(url, {
				_method: 'PATCH',
				_token: this.$root.store.csrf_token,
				quantity: product.new_quantity
			})
				//TODO
				.then(R.pathOr({}, ['body']))
				.then(body => {
					this.alert(body)
					this.store.cart.data = body.data
				})
				.catch(this.$root.ajaxErrAlerting)
		},

        addToCart(order_key, id) {
            this.getData(order_key, id).then((data) => {
                this.$http.post(this.store.routes.addToCart.post, data)
                    .then(R.pathOr({}, ['body']))
                    .then(body => {
                        this.store.menus.cart.isOpen = true;
                        this.store.cart.data = body.data
                        this.modal = false
                        //this.alert(body)
                    })
                    .catch(this.$root.ajaxErrAlerting)
            });
        },

		removeFromCart(item_id) {
			let url = R.pipe(
				R.replace('__id__', item_id),
			)(this.$root.store.routes.removeFromCart.post)

			this.$http.post(url, {
				_method: 'DELETE',
				_token: this.$root.store.csrf_token
			})
				//TODO
				.then(R.pathOr({}, ['body']))
				.then(body => {
					this.$root.alert(body)
					this.$root.store.cart.data = body.data
				})
				.catch(this.$root.ajaxErrAlerting)
		},

        getStickerPreview(order_key, item_id) {
            if (this.previewCache[item_id]) {//para no hacer un get cada vez que se vea el mismo sticker
                this.previewedSticker = this.previewCache[item_id]
                return
            }

            this.getStickerPreviewHttp(order_key, item_id)
                //TODO
                .then(tap.c('getStickerPreview'))
                .then(R.path(['body']))
                .then(data => {
                    this.previewCache[item_id] = data
                    this.previewedSticker = this.previewCache[item_id]
                    return data
                })
                .catch(err => {
                    this.alertError([err.statusText])
                    this.previewedSticker = { something: 'blaaa' }
                })
        },

		closeStickerPreview() {
			this.previewedSticker = {}
		},

		getData(order_key, item_id) {
			return this.getStickerPreviewHttp(order_key, item_id)
				.then(data => {
					return {
						stamps: data.body.customizations.stamps,
						texts: data.body.customizations.texts,
						sku: data.body.sku,
						quantity: 1,
						_token: this.store.csrf_token,
					};

				})
				.catch(err => {
					this.alertError([err.statusText])
					//this.previewedSticker = {something: 'blaaa'}
				})
		},

        getStickerPreviewHttp(orderKey, itemId) {
            const params = (new URL(document.location)).searchParams;

            // There are only 2 ways in which someone can access this page.
            // Has a valid signature or is logged in as the owner of the order
            if (params.has('signature')) {
                const signature = params.get('signature');
                const url = R.pipe(
                    R.replace('__order_key__', orderKey),
                    R.replace('__item_id__', itemId),
                )(this.$root.store.routes.publicOrderStickerPreview.get)

                return this.$http.get(url, {
                    params: {
                        signature
                    }
                });
            } else {
                const url = R.pipe(
                    R.replace('__order_key__', orderKey),
                    R.replace('__item_id__', itemId),
                )(this.$root.store.routes.userOrderStickerPreview.get)

                return this.$http.get(url);
            }
        }
	}
};



// WEBPACK FOOTER //
// ./resources/assets/js/vue/main/confirmation.js